module.exports = __webpack_public_path__ + "8a9f51af9bdb23cc50e20692ffe860e7.svg";